import { AdminUsersDetailPage } from './admin-users-detail';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FlxCommonsModule } from "@questrade/flx-commons";
import { DevBreadcrumbsComponentModule } from '../../components/dev-breadcrumbs/dev-breadcrumbs.module';

@NgModule({
    declarations: [
        AdminUsersDetailPage,
    ],
    imports: [
        DevBreadcrumbsComponentModule,
        FlxCommonsModule,
        IonicPageModule.forChild(AdminUsersDetailPage),
    ],
    exports: [
        AdminUsersDetailPage
    ]
})
export class AdminUsersDetailPageModule { }




// WEBPACK FOOTER //
// ./src/pages/admin-users-detail/admin-users-detail.module.ts